export const getAbsoluteUrl = (path: string): string => {
  if (typeof window !== "undefined") {
    return path.includes("http") ? path : `${location.origin}${path}`;
  }

  return path;
};
